import { Label } from '../../../../components/ui/label';
import { RadioGroup, RadioGroupItem } from '../../../../components/ui/radio-group';
import { useAnalytics } from '../../../../core/analytics/useAnalytics';

const OPTIONS = ['dark', 'light'] as const;

interface CustomVariantToggleProps {
  variant: 'light' | 'dark';
  onChange: (variant: 'light' | 'dark') => void;
}

/**
 * "Edit variant:" dark/light toggle for the Custom editor-colors section
 * (Slice 3 dialog iteration) — replaces the old "switch the app theme to
 * edit the other" caption with an in-dialog control, so editing the
 * non-active app-mode variant no longer requires leaving the dialog.
 */
export function CustomVariantToggle({ variant, onChange }: CustomVariantToggleProps) {
  const { track } = useAnalytics();

  return (
    <div className="flex items-center gap-3">
      <Label className="cursor-default text-xs text-muted-foreground">Edit variant:</Label>
      <RadioGroup
        value={variant}
        onValueChange={(value) => {
          const next = value as 'light' | 'dark';
          if (next === variant) return;
          onChange(next);
          track('feature:editor_custom_variant_switched', { variant: next });
        }}
        className="flex items-center gap-3"
        data-testid="custom-variant-toggle"
      >
        {OPTIONS.map((opt) => (
          <div key={opt} className="flex items-center gap-1.5">
            <RadioGroupItem id={`custom-variant-${opt}`} value={opt} data-testid={`custom-variant-${opt}`} />
            <Label htmlFor={`custom-variant-${opt}`} className="cursor-pointer text-xs font-normal capitalize">
              {opt}
            </Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
}
